// Widget Scripts
import customTicketButton from './js/widgets/customTicketButton.js';
import themeBackground from './js/widgets/themeBackground.js';
import mainSlideshow from './js/widgets/mainSlideshow.js';
import autoEventFeed from './js/widgets/autoEventFeed.js';
import customCards from './js/widgets/customCards.js';
import customSeoBlock from './js/widgets/seo-signup/customSeoBlock.js';
import customSignup from './js/widgets/seo-signup/customSignup.js';
import scrollerSponsors from './js/widgets/scrollerSponsors.js';

// Custom Theme Scripts
import './js/localjs.js';

// Initialize Homepage Widgets
$(document).ready(function () {
  themeBackground();
  customTicketButton();

  if (globalThis.location.pathname === '/') {
    mainSlideshow();
    autoEventFeed();
    customCards();
    customSeoBlock();
    customSignup();
    scrollerSponsors();
  }
});
